import { useEffect, useState } from "react";
import "./write.css";
import axios from "axios";
import { getToken } from "../../helpers/authHelpers";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { useParams } from "react-router-dom";

export default function Write() {
  const { user } = useAuthContext();
  const [categoriesUpdated, setCategoriesUpdated] = useState(false);

  const [message, setMessage] = useState("");
  const [submitAction, setSubmitAction] = useState("publish");
  const navigate = useNavigate();

  const [blogEntryImgPreview, setBlogEntryImgPreview] = useState(
    "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
  );
  // const [allCategories, setAllCategories] = useState([]); // fetched from Strapi
  const [categoryInput, setCategoryInput] = useState(""); // text field
  const [selectedCategories, setSelectedCategories] = useState([]); // array of strings

  const [blogEntryData, setBlogEntryData] = useState({
    title: "",
    email: "",
    story: "",
    categories: [],
    main_img: "",
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/categories`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          }
        );

        const formatted = res.data.data.map((cat) => ({
          id: cat.documentId,
          name: cat.name,
          active: false,
        }));

        setSelectedCategories(formatted);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };

    fetchCategories();
  }, []);

  //Edit post
  const { postId } = useParams();

  useEffect(() => {
    const fetchPost = async () => {
      if (!postId) return;
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/posts/${postId}?populate[photo]=true&populate[categories]=true`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
            },
          }
        );

        const post = res.data.data;

        setBlogEntryData({
          title: post.title,
          story: post.description,
          categories: post.categories || [],
          main_img: post.photo || null,
        });
        if (post.photo?.url) {
          setBlogEntryImgPreview(
            `${process.env.REACT_APP_UPLOAD_URL}${post.photo.url}`
          );
        }
      } catch (err) {
        console.error("Failed to load post for editing", err);
      }
    };

    fetchPost();
  }, [postId]);

  useEffect(() => {
    if (
      !categoriesUpdated &&
      selectedCategories.length > 0 &&
      blogEntryData.categories.length > 0
    ) {
      updateCategories();
      setCategoriesUpdated(true);
    }
  }, [selectedCategories, blogEntryData.categories, categoriesUpdated]);

  //End Edit post

  //Clean up file preview URL on unmount
  useEffect(() => {
    return () => {
      if (blogEntryImgPreview) URL.revokeObjectURL(blogEntryImgPreview);
    };
  }, [blogEntryImgPreview]);

  const handleCategoryInput = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const trimmed = categoryInput.trim();
      const formattedInput = {
        name: trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase(),
        active: true,
      };

      const exists = selectedCategories.some(
        (cat) => cat.name.toLowerCase() === trimmed.toLowerCase()
      );

      if (trimmed && !exists) {
        setSelectedCategories([...selectedCategories, formattedInput]);
      }
      setCategoryInput("");
    }
  };

  const removeCategory = (catToRemove) => {
    setSelectedCategories((prev) =>
      prev.map((cat) =>
        cat.name === catToRemove ? { ...cat, active: false } : cat
      )
    );
  };

  const updateCategories = () => {
    const postCats = blogEntryData.categories.map((cat) => cat.name);
    setSelectedCategories((prev) =>
      prev.map((cat) => ({
        ...cat,
        active: postCats.includes(cat.name),
      }))
    );
  };

  const restoreCategory = (catToRestore) => {
    setSelectedCategories((prev) =>
      prev.map((cat) =>
        cat.name === catToRestore ? { ...cat, active: true } : cat
      )
    );
  };

  const createPost = async (e) => {
    e.preventDefault();

    const fileInput = document.getElementById("fileInput");
    const file = fileInput?.files[0];

    const title = e.target.title.value; // first input after file input
    const description = e.target.story.value; // textarea
    // const categories = e.target.categories.value; // categories input
    let uploadedImageId = null;

    // Upload the image if it exists
    if (file) {
      try {
        const { data: imageData } = await sendImage(file);
        uploadedImageId = imageData[0]?.id;
      } catch (uploadErr) {
        console.warn("Image upload failed:", uploadErr.message || uploadErr);
        setMessage("Image upload failed:", uploadErr.message || uploadErr);
        // You could also show a message to the user here that image upload failed
      }
    }

    let author = await getAuthorId();
    let catg = postId
      ? selectedCategories.filter((cat) => cat.active).map((cat) => cat.id)
      : selectedCategories
          .filter((cat) => cat.active)
          .map((cat) => ({ name: cat.name }));

    const postPayload = {
      data: {
        title: title,
        description: description,
        author: author,
        ...(uploadedImageId && { photo: uploadedImageId }),
        categories: catg,
      },
    };

    const endpoint = postId
      ? `${process.env.REACT_APP_API_URL}/posts/${postId}`
      : `${process.env.REACT_APP_API_URL}/posts`;
    const method = postId ? "put" : "post";

    try {
      // const res = await axios.post(
      //   `${process.env.REACT_APP_API_URL}/posts`,
      //   postPayload,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${getToken()}`,
      //     },
      //   }
      // );

      const res = await axios[method](endpoint, postPayload, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      setMessage("Post created successfully:", res.data);
      // Optionally, navigate or reset form here

      if (submitAction === "publishNew") {
        resetForm();
      } else {
        navigate("/");
      }
    } catch (postErr) {
      console.error(
        "Failed to create post:",
        postErr.response?.data || postErr.message
      );
      setMessage(
        "Failed to create post:",
        postErr.response?.data || postErr.message
      );
      // Optionally, show user-friendly error
    }
  };

  async function getAuthorId() {
    const authorRes = await axios.get(
      `${process.env.REACT_APP_API_URL}/authors?filters[user][id][$eq]=${user.id}`,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );

    // return authorRes.data.data[0]?.id;

    return authorRes.data.data[0]?.documentId;
  }

  function createCategoriesArr(categories) {
    let catArray = [
      ...new Set(
        categories
          .map((cat) => cat.trim())
          .map(
            (cat) => cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase()
          )
      ),
    ];
    return catArray.map((cat) => {
      return {
        name: cat,
      };
    });
  }

  async function sendImage(file) {
    const formDataToSend = new FormData();
    formDataToSend.append("files", file);

    const uploadRes = await axios.post(
      `${process.env.REACT_APP_API_URL}/upload`,
      formDataToSend,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return uploadRes;
  }

  const handleImgChange = (e) => {
    const file = e.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      setBlogEntryImgPreview("");
      // Clean up old preview
      if (blogEntryImgPreview) URL.revokeObjectURL(blogEntryImgPreview);

      const previewUrl = URL.createObjectURL(file);

      setBlogEntryData((prev) => ({
        ...prev,
        main_img: file,
      }));

      setBlogEntryImgPreview(previewUrl);
    }
  };

  const resetForm = () => {
    setBlogEntryData({
      title: "",
      email: "",
      story: "",
      categories: [],
      main_img: "",
    });
    setCategoryInput("");
    setSelectedCategories([]);
    setBlogEntryImgPreview(
      "https://images.pexels.com/photos/6685428/pexels-photo-6685428.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
    );
    document.getElementById("fileInput").value = null;
  };

  return (
    <div className="write">
      <img className="writeImg" src={blogEntryImgPreview} alt="blog entry" />
      <form className="writeForm" onSubmit={createPost}>
        <div>
          <label htmlFor="fileInput">
            <i className="writeIcon fas fa-plus"></i>
          </label>
          <input
            name="photo"
            id="fileInput"
            type="file"
            onChange={handleImgChange}
            style={{ display: "none" }}
          />
          <p>{blogEntryImgPreview}</p>
        </div>

        <div className="writeFormGroup">
          <input
            name="title"
            className="writeInput"
            placeholder="Title"
            type="text"
            value={blogEntryData.title}
            onChange={(e) => {
              e.preventDefault();
              setBlogEntryData((prev) => ({ ...prev, title: e.target.value }));
            }}
            autoFocus={true}
            required
          />
        </div>
        {/* <div className="categories">
          <input
            name="categories"
            placeholder="keywords (comma separated)"
            type="text"
          />
        </div> */}
        <div className="categories">
          <label htmlFor="categoriesInput">Categories:</label>
          <div className="category-list">
            {selectedCategories.map((cat, i) => (
              <button
                key={"infotag" + i}
                type="button"
                className={`category-btn ${cat.active ? "" : "inactive"}`}
                onClick={() =>
                  cat.active
                    ? removeCategory(cat.name)
                    : restoreCategory(cat.name)
                }
              >
                {cat.name}
                <i
                  className={`fas fa-${cat.active ? "times" : "undo"}`}
                  style={{ marginLeft: "5px" }}
                ></i>
              </button>
            ))}
            <input
              id="categoriesInput"
              type="text"
              placeholder="Type and press Enter"
              value={categoryInput}
              onChange={(e) => setCategoryInput(e.target.value)}
              onKeyDown={handleCategoryInput}
            />
          </div>
          {/* <div className="all-categories-hint">
            <small>Suggested: {allCategories.join(", ")}</small>
          </div> */}
        </div>

        <div className="writeFormGroup">
          <textarea
            name="story"
            className="writeInput writeText"
            placeholder="Tell your story..."
            type="text"
            value={blogEntryData.story}
            onChange={(e) => {
              e.preventDefault();
              setBlogEntryData((prev) => ({ ...prev, story: e.target.value }));
            }}
            autoFocus={true}
            required
          />
        </div>

        <div className="row">
          <button
            className="writeSubmit"
            type="submit"
            onClick={() => setSubmitAction("publish")}
          >
            Publish
          </button>

          <button
            className="writeSubmit"
            type="submit"
            onClick={() => setSubmitAction("publishNew")}
          >
            Publish & Create New Entry
          </button>
        </div>
      </form>

      {message && <p className="error">{message}</p>}
      <div
        className="toast align-items-center info-toast"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">fsdfsd{message}</div>
          <button
            type="button"
            className="btn-close me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
